module.exports = __webpack_public_path__ + "c2a6421f298b3ceb85fabeecccc9f03d.svg";